import { React, useState, useEffect } from "react";
import {
  useGetLatestIdQuery,
  useGetAllDapartmentQuery,
  useGetEmployeeListQuery,
  useGetWorkLocationsQuery,
  useGetAllDesignationsQuery,
  useGetAllHolidayCalenderQuery,
  useGetAllEmployeeTypesQuery,
  useGetManagersListsQuery,
  useGetSuperAdminManagersListQuery,
} from "../../api/addEmployeeApi";
import { useSelector, useDispatch } from "react-redux";
import {
  updateEmployeeDetails,
  clearErrorState,
  updateErrorState,
} from "../../store/reducers/addEmployeeSlice";
import { updateErrorMessage } from "../../store/reducers/errorMessageSlice";
import TextField from "../../Components/customComponents/customTextField";
import CustomRadioSelect from "../../Components/customComponents/customRadioSelection";
import Select from "../../Components/customComponents/customSelect";
import { upperCase, values } from "lodash";
import { useGetAllShiftsQuery } from "../../api/shiftsAPI";

const BasicInfo = ({ isInvite }) => {
  const empState = useSelector((state) => state.addEmployee.employeeDetails);
  const errorState = useSelector((state) => state.addEmployee.errorState);
  const feildDisabled = useSelector(
    (state) => state.addEmployee.feildsDisabled,
  );
  const errorMessageState = useSelector(
    (state) => state.errorMessage.errorMessage,
  );
  const [employeeIdError, setEmployeeIdError] = useState("");
  const dispatch = useDispatch();
  const { isViewedEMployee, inviteEmployeeMetaData } = useSelector(
    (state) => state.addEmployee,
  );
  const {
    data: allShifts,
    isLoading: isLoadingShift,
    isSuccess: isSuccessShift,
    isError: isErrorShift,
    refetch: isRefetchShift,
  } = useGetAllShiftsQuery({}, { refetchOnMountOrArgChange: true });
  const {
    data: empLatestId,
    isLoading: isLoadingEmpLatestId,
    isSuccess: isSuccessEmpLatestId,
    isError: isErrorEmpLatestId,
    refetch: isRefetchEmpLatestId,
  } = useGetLatestIdQuery({}, { skip: isInvite });

  const {
    data: empList,
    isLoading: isLoadingEmpList,
    isSuccess: isSuccessEmpList,
    isError: isErrorEmpList,
    refetch: isRefetchEmpList,
  } = useGetEmployeeListQuery({}, { skip: isInvite });

  const {
    data: workLocations,
    isLoading: isLoadingWorkLocations,
    isSuccess: isSuccessWorkLocation,
    isError: isErrorWorkLocations,
    refetch: isRefetchWorklocations,
  } = useGetWorkLocationsQuery({}, { skip: isInvite });

  const {
    data: allDeapartments,
    isLoading: isLoadingAllDepartments,
    isSuccess: isSuccessAllDepartments,
    isError: isErrorAllDepartments,
    refetch: isRefetchDepartments,
  } = useGetAllDapartmentQuery({}, { skip: isInvite });

  const {
    data: allManagers,
    isLoading: isLoadingAllManagers,
    isSuccess: isSuccessAllManagers,
    isError: isErrorAllManagers,
    refetch: isRefetchManagers,
  } = useGetManagersListsQuery({}, { skip: isViewedEMployee });

  const {
    data: superAdminManagers,
  } = useGetSuperAdminManagersListQuery({}, { skip: !isViewedEMployee });

  const {
    data: allDesignation,
    isLoading: isLoadingAllDesignation,
    isSuccess: isSuccessAllDesignation,
    isError: isErrorAllDesignation,
    refetch: isRefetchDesignation,
  } = useGetAllDesignationsQuery({}, { skip: isInvite });

  const {
    data: allHolidayCalender,
    isLoading: isLoadingAllHolidayCalender,
    isSuccess: isSuccessAllHolidayCalender,
    isError: isErrorAllHolidayCalender,
    refetch: isRefetchHolidayCalender,
  } = useGetAllHolidayCalenderQuery({}, { skip: isInvite });

  const {
    data: allEmployeeTypes,
    isLoading: isLoadingAllEmployeeTypes,
    isSuccess: isSuccessAllEmployeeTypes,
    isError: isErrorAllEmployeeTypes,
    refetch: isRefetchEmployeeTypes,
  } = useGetAllEmployeeTypesQuery({}, { skip: isInvite });

  const options1 = [
    { value: "CONFIRMED", label: "CONFIRMED" },
    { value: "CONSULTANT", label: "CONSULTANT" },
    { value: "PROBATION", label: "PROBATION" },
  ];

  const managerOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  const allShitsOptions = allShifts
    ? allShifts.data
        .filter((shift) => shift.isActive)
        .map((item) => {
          return { value: item._id, label: item.shiftName };
        })
    : [];

  const allWorkLocationOptions = workLocations
    ? workLocations
        .filter((location) => location.isActive)
        .map((item) => {
          return { value: item._id, label: item.location };
        })
    : [];

  const allDeapartmentsOptions = allDeapartments
    ? allDeapartments
        .filter((department) => department.isActive)
        .map((item) => {
          return { value: item._id, label: item.departmentName };
        })
    : [];

  const designationOptions = allDesignation
    ? Object.entries(
        allDesignation[empState?.professionalDetails?.department] || {},
      ).map((item) => {
        return { value: item[1], label: item[0] };
      })
    : [];

  const holidayCalenderOptions = allHolidayCalender
    ? Object.entries(allHolidayCalender || {}).map((item) => {
        return { value: item[0], label: item[1] };
      })
    : [];

  const allEmployeeTypesOptions = allEmployeeTypes
    ? allEmployeeTypes
        .filter((type) => type.isActive)
        .map((item) => {
          return { value: item._id, label: item.employeeCategory };
        })
    : [];

  const empListOptions = isViewedEMployee
    ? (superAdminManagers?.data ?? []).map((emp) => ({
        value: emp.id,
        label: emp.name,
      }))
    : (allManagers?.data ?? []).map((emp) => ({
        value: emp.employeeId,
        label: emp.name,
      }));

  const [selectedOption1, setSelectedOption1] = useState(options1[0].value);

  const handleSelectChange = (e) => {
    if (e.target.name === "employeeDetails.professionalDetails.department") {
      allDeapartments.map((each) => {
        if (each._id === e.target.value) {
          dispatch(
            updateEmployeeDetails({
              value: each.defaultManager,
              path: "employeeDetails.professionalDetails.managerId",
            }),
          );
        }
      });
    }

    if (e.target.name === "employeeDetails.isManager") {
      let value;
      e.target.value === "true" ? (value = true) : (value = false);
      dispatch(updateEmployeeDetails({ value: value, path: e.target.name }));
    } else {
      dispatch(
        updateEmployeeDetails({ value: e.target.value, path: e.target.name }),
      );
    }
  };

  const handleOptionSelect = (e) => {
    dispatch(
      updateEmployeeDetails({ value: e.target.value, path: e.target.name }),
    );
    // setSelectedOption(e.target.value);
  };

  const options = ["MALE", "FEMALE", "OTHER"];

  const handleChange = (e) => {
    if (
      empState.professionalDetails.dateofJoining &&
      e.target.name == "employeeDetails.professionalDetails.probationPeriod"
    ) {
      if (e.target.value) {
        let days = parseInt(e.target.value, 10);
        const date = new Date(empState.professionalDetails.dateofJoining);

        date.setDate(date.getDate() + days);
        dispatch(
          updateEmployeeDetails({
            value: date.toISOString(),
            path: "employeeDetails.professionalDetails.confirmationDate",
          }),
        );
      }
    }
    if (
      e.target.name == "employeeDetails.personalDetails.dob" ||
      e.target.name == "employeeDetails.professionalDetails.dateofJoining" ||
      e.target.name == "employeeDetails.professionalDetails.confirmationDate"
    ) {
      // dispatch(
      //   updateEmployeeDetails({
      //     value: empLatestId.employeeId,
      //     path: "employeeDetails.professionalDetails.employeeId",
      //   })
      // );
      dispatch(
        updateEmployeeDetails({
          value: new Date(e.target.value).toISOString(),
          path: e.target.name,
        }),
      );
    } else if (
      e.target.name == "employeeDetails.personalDetails.aadharNumber"
    ) {
      // dispatch(
      //   updateEmployeeDetails({
      //     value: empLatestId.employeeId,
      //     path: "employeeDetails.professionalDetails.employeeId",
      //   })
      // );
      if (/^\d+$/.test(e.target.value) && e.target.value.length < 13) {
        dispatch(
          updateEmployeeDetails({ value: e.target.value, path: e.target.name }),
        );
      }
      if (e.target.value.length == 0) {
        dispatch(
          updateEmployeeDetails({ value: e.target.value, path: e.target.name }),
        );
      }
    } else if (
      e.target.name === "employeeDetails.professionalDetails.probationPeriod"
    ) {
      if (e.target.value > 366) {
        dispatch(updateEmployeeDetails({ value: 365, path: e.target.name }));
      } else if (e.target.value < 0) {
        dispatch(updateEmployeeDetails({ value: 0, path: e.target.name }));
      } else {
        dispatch(
          updateEmployeeDetails({ value: e.target.value, path: e.target.name }),
        );
      }
    } else if (
      e.target.name === "employeeDetails.professionalDetails.noticePeriod"
    ) {
      if (e.target.value === "") {
        dispatch(updateEmployeeDetails({ value: "", path: e.target.name }));
      } else if (e.target.value < 0) {
        dispatch(updateEmployeeDetails({ value: 0, path: e.target.name }));
      } else {
        dispatch(
          updateEmployeeDetails({ value: e.target.value, path: e.target.name }),
        );
      }
    } else if (e.target.name === "employeeDetails.salary") {
      if (e.target.value < 0 || e.target.value === "") {
        dispatch(updateEmployeeDetails({ value: "", path: e.target.name }));
      } else {
        dispatch(
          updateEmployeeDetails({
            value: +e.target.value,
            path: e.target.name,
          }),
        );
      }
    } else if (
      e.target.name === "employeeDetails.professionalDetails.totalExperience" ||
      e.target.name ===
        "employeeDetails.professionalDetails.currentCompanyExperience"
    ) {
      if (e.target.value < 0) {
        dispatch(updateEmployeeDetails({ value: 0, path: e.target.name }));
      } else {
        dispatch(
          updateEmployeeDetails({ value: Number(e.target.value), path: e.target.name }),
        );
      }
    } else if (
      e.target.name == "employeeDetails.professionalDetails.employeeId"
    ) {
      let upCaseID = e.target.value.toUpperCase();
      dispatch(
        updateEmployeeDetails({
          value: upCaseID,
          path: "employeeDetails.professionalDetails.employeeId",
        }),
      );
    } else {
      dispatch(
        updateEmployeeDetails({ value: e.target.value, path: e.target.name }),
      );
    }
  };

  useEffect(() => {
    if (!isInvite) {
      isRefetchEmpLatestId();
      isRefetchEmpList();
      isRefetchDepartments();
      isRefetchDesignation();
      isRefetchEmployeeTypes();
      isRefetchHolidayCalender();
      isRefetchWorklocations();
      if (!isViewedEMployee) {
        isRefetchManagers();
      }
    }
  }, []);

  return (
    <>
      <h1 className="text-2xl mb-10">Step 1:PROFESSIONAL DETAILS</h1>

      <div className="flex justify-around">
        <div className={"flex flex-col justify-center items-end "}>
          <TextField
            name="employeeDetails.professionalDetails.employeeId"
            label="Employee Number"
            type="text"
            value={empState?.professionalDetails?.employeeId}
            onChange={handleChange}
            error={employeeIdError}
            onBlur={(e) =>
              e.target.value.length < 3
                ? setEmployeeIdError("Id Should have atleast 3 Characters.")
                : setEmployeeIdError("")
            }
            isMandatory={true}
            disabled={isInvite || isViewedEMployee}
            className={`${
              empState?.professionalDetails?.employeeId === "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <TextField
            name="employeeDetails.firstName"
            label="First Name"
            type="text"
            value={empState.firstName}
            onChange={handleChange}
            isMandatory={true}
            error={errorState.step0.firstName ? errorState.step0.firstName : ""}
            disabled={feildDisabled || isViewedEMployee}
            onBlur={() => {
              dispatch(updateErrorState({ activeTab: 0, field: "firstName" }));
            }}
            className={`${
              empState.firstName === "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <TextField
            name="employeeDetails.lastName"
            label="Last Name"
            type="text"
            value={empState.lastName}
            onChange={handleChange}
            isMandatory={true}
            error={errorState.step0.lastName ? errorState.step0.lastName : ""}
            disabled={feildDisabled || isViewedEMployee}
            onBlur={() => {
              dispatch(updateErrorState({ activeTab: 0, field: "lastName" }));
            }}
            className={`${
              empState.lastName === "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <TextField
            name="employeeDetails.professionalDetails.companyEmail"
            label="Company Email"
            type="email"
            onChange={handleChange}
            isMandatory={false}
            value={empState?.professionalDetails?.companyEmail}
            error={
              errorState.step0.companyEmail ? errorState.step0.companyEmail : ""
            }
            disabled={isInvite || isViewedEMployee}
            //
            onBlur={() => {
              dispatch(
                updateErrorState({ activeTab: 0, field: "companyEmail" }),
              );
            }}
            //className = {`${empState.professionalDetails.companyEmail === "" && errorMessageState === true && "border border-red-500"}`}
          />

          <Select
            label="Manager"
            name={"employeeDetails.isManager"}
            options={managerOptions}
            onChange={handleSelectChange}
            value={empState.isManager}
            disabled={isInvite || isViewedEMployee}
            isMandatory={true}
            className={`${
              empState.isManager === "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <Select
            label="Status"
            name={"employeeDetails.professionalDetails.status"}
            options={options1}
            onChange={handleSelectChange}
            value={empState?.professionalDetails?.status}
            disabled={isInvite || isViewedEMployee}
            isMandatory={true}
            className={`${
              empState?.professionalDetails?.status === "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <TextField
            name="employeeDetails.professionalDetails.dateofJoining"
            label="Date of Joining"
            type="date"
            onChange={handleChange}
            value={empState?.professionalDetails?.dateofJoining?.split("T")[0]}
            disabled={isInvite || isViewedEMployee}
            isMandatory={true}
            className={`${
              empState?.professionalDetails?.dateofJoining?.split("T")[0] ===
                "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
            max={new Date().toISOString()?.split("T")[0]}
          />

          <TextField
            name="employeeDetails.professionalDetails.noticePeriod"
            label="Notice Period (Days)"
            type="number"
            onChange={handleChange}
            placeHolder="Days"
            value={empState?.professionalDetails?.noticePeriod}
            disabled={isInvite || isViewedEMployee}
            helperText="Enter notice period in days"
            isMandatory={true}
            min={0}
            className={`${
              (empState?.professionalDetails?.noticePeriod === "" ||
                empState?.professionalDetails?.noticePeriod === 0) &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          {!isInvite ? (
            <Select
              label="Shift"
              name={"employeeDetails.professionalDetails.shift"}
              options={allShitsOptions}
              onChange={handleSelectChange}
              value={empState?.professionalDetails?.shift}
              disabled={isInvite || isViewedEMployee}
              isMandatory={true}
              className={`${
                empState?.professionalDetails?.shift === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
          ) : (
            <TextField
              name="employeeDetails.professionalDetails.shift"
              label="Shift"
              type="text"
              value={
                inviteEmployeeMetaData[empState?.professionalDetails?.shift]
              }
              disabled={true}
              isMandatory={true}
            />
          )}
          {!isInvite ? (
            <Select
              label="Location"
              name="employeeDetails.professionalDetails.workLocation"
              options={allWorkLocationOptions}
              value={empState?.professionalDetails?.workLocation}
              onChange={handleSelectChange}
              disabled={isInvite || isViewedEMployee}
              isMandatory={true}
              className={`${
                empState?.professionalDetails?.workLocation === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
          ) : (
            <TextField
              name="employeeDetails.professionalDetails.workLocation"
              label="Location"
              type="text"
              value={
                inviteEmployeeMetaData[
                  empState?.professionalDetails?.workLocation
                ]
              }
              disabled={true}
              isMandatory={true}
            />
          )}
        </div>
        <div
          className={`${
            isInvite ? "justify-start" : "justify-center"
          } flex flex-col items-start `}
        >
          {!isInvite ? (
            <Select
              label="Department"
              options={allDeapartmentsOptions}
              name="employeeDetails.professionalDetails.department"
              value={empState?.professionalDetails?.department}
              onChange={handleSelectChange}
              disabled={isInvite || isViewedEMployee}
              isMandatory={true}
              className={`${
                empState?.professionalDetails?.department === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
          ) : (
            <TextField
              name="employeeDetails.professionalDetails.department"
              label="Department"
              type="text"
              value={
                inviteEmployeeMetaData[
                  empState?.professionalDetails?.department
                ]
              }
              disabled={true}
              isMandatory={true}
            />
          )}

          {!isInvite ? (
            <Select
              label="Designation"
              name="employeeDetails.professionalDetails.currentDesignation"
              options={designationOptions}
              value={empState?.professionalDetails?.currentDesignation}
              onChange={handleSelectChange}
              disabled={isInvite || isViewedEMployee}
              isMandatory={true}
              className={`${
                empState?.professionalDetails?.currentDesignation === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
          ) : (
            <TextField
              name="employeeDetails.professionalDetails.currentDesignation"
              label="Designation"
              type="text"
              value={
                inviteEmployeeMetaData[
                  empState?.professionalDetails?.currentDesignation
                ]
              }
              disabled={true}
              isMandatory={true}
            />
          )}

          {!isInvite && (
            <Select
              label="Holiday Category"
              name="employeeDetails.professionalDetails.holidayCalender"
              options={holidayCalenderOptions}
              value={empState?.professionalDetails?.holidayCalender}
              onChange={handleSelectChange}
              disabled={isInvite || isViewedEMployee}
              isMandatory={true}
              className={`${
                empState?.professionalDetails?.holidayCalender === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
          )}

          {!isInvite && (
            <Select
              name="employeeDetails.professionalDetails.managerId"
              label="Reporting Manager"
              options={empListOptions}
              onChange={handleSelectChange}
              value={empState?.professionalDetails?.managerId}
              disabled={isInvite || isViewedEMployee}
              isMandatory={true}
              className={`${
                empState?.professionalDetails?.managerId === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
          )}

          {!isInvite ? (
            <Select
              name="employeeDetails.professionalDetails.employeeType"
              label="Employee Type"
              options={allEmployeeTypesOptions}
              onChange={handleSelectChange}
              value={empState?.professionalDetails?.employeeType}
              disabled={isInvite || isViewedEMployee}
              isMandatory={true}
              className={`${
                empState?.professionalDetails?.employeeType === "" &&
                errorMessageState === true &&
                "border border-red-500"
              }`}
            />
          ) : (
            <TextField
              name="employeeDetails.professionalDetails.employeeType"
              label="Employee Type"
              type="text"
              value={
                inviteEmployeeMetaData[
                  empState?.professionalDetails?.employeeType
                ]
              }
              disabled={true}
              isMandatory={true}
            />
          )}

          <TextField
            name="employeeDetails.professionalDetails.probationPeriod"
            label="Probation Period (Days)"
            type="number"
            onChange={handleChange}
            placeHolder="Days"
            value={empState?.professionalDetails?.probationPeriod}
            disabled={isInvite || isViewedEMployee}
            helperText="Enter probation period in days"
            isMandatory={true}
            min={0}
            className={`${
              (empState?.professionalDetails?.probationPeriod === "" ||
                empState?.professionalDetails?.probationPeriod === 0) &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <TextField
            name="employeeDetails.professionalDetails.confirmationDate"
            label="Confirmation Date"
            type="date"
            onChange={handleChange}
            value={
              empState?.professionalDetails?.confirmationDate?.split("T")[0]
            }
            disabled={isInvite || isViewedEMployee}
            isMandatory={true}
          />
          {!isInvite && (
            <TextField
              name="employeeDetails.salary"
              label="Annual Salary"
              type="number"
              onChange={handleChange}
              placeHolder="Salary"
              value={empState?.salary}
              disabled={isInvite || isViewedEMployee}
              min={0}
            />
          )}

          <TextField
            name="employeeDetails.professionalDetails.totalExperience"
            label="Total Experience"
            type="number"
            onChange={handleChange}
            placeHolder="Years"
            disabled={isViewedEMployee}
            helperText="Enter total experience in years"
            value={empState?.professionalDetails?.totalExperience}
            min={0}
            isMandatory={true}
            className={`${
              empState?.professionalDetails?.totalExperience === "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <TextField
            name="employeeDetails.professionalDetails.currentCompanyExperience"
            label="Current Company Experience (Years)"
            type="number"
            onChange={handleChange}
            disabled={isViewedEMployee}
            helperText="Enter current company experience in years"
            placeHolder="Years"
            min={0}
            value={empState?.professionalDetails?.currentCompanyExperience}
            isMandatory={true}
            className={`${
              empState?.professionalDetails?.currentCompanyExperience === "" &&
              errorMessageState === true &&
              "border border-red-500"
            }`}
          />

          <TextField
            name="employeeDetails.professionalDetails.referedBy"
            label="Referred By"
            type="text"
            onChange={handleChange}
            disabled={isViewedEMployee}
            placeHolder=""
            value={empState?.professionalDetails?.referedBy}
            isMandatory={false}
          />
        </div>
      </div>
    </>
  );
};

export default BasicInfo;
